import { GenericObject } from "../custom-types/generic-object";
export function generateQueryString(params: GenericObject): string {
    const queryParams = new URLSearchParams();

    for (const key in params) {
        if (params.hasOwnProperty(key) && params[key] != null) {
            const value = params[key];
            if (Array.isArray(value)) {
                value.forEach((val) => {
                    queryParams.append(key, String(val));
                });
            } else {
                queryParams.append(key, value);
            }
        }
    }

    return queryParams.toString();
}
